import { type ReactNode, useEffect, useId, useRef } from 'react';

interface ModalProps {
  readonly title: string;
  readonly open: boolean;
  readonly onClose: () => void;
  readonly children: ReactNode;
  readonly wide?: boolean;
}

/** A native modal dialog: focus is trapped by the browser, Escape closes, focus returns afterwards. */
export function Modal({ title, open, onClose, children, wide = false }: ModalProps) {
  const ref = useRef<HTMLDialogElement>(null);
  // Unique per dialog: several dialogs can be in the document at once.
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current;
    if (dialog === null) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      className={wide ? 'modal modal--wide' : 'modal'}
      aria-labelledby={titleId}
      onClose={onClose}
    >
      <header className="modal__header">
        <h2 id={titleId}>{title}</h2>
        <button type="button" className="button button--ghost" onClick={onClose} aria-label="סגירה">
          ✕
        </button>
      </header>
      <div className="modal__body">{children}</div>
    </dialog>
  );
}
